import React from "react"
import styled, { css } from "styled-components"

import Button from "./button-internal-link"
import Build from "@images/abcares/abcares-build.jpg"
import Serve from "@images/abcares/abcares-serve.jpg"
import Volunteer from "@images/abcares/abcares-volunteer.jpg"

import { getWalledLink } from "@utils/walled"

const size = {
  tablet: 950,
  mobile: 750,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div`
  background: ${props => props.backgroundColor || "#F7FAFC"};
  a {
    padding: auto 24px;
    max-width: 264px;
    ${below.mobile`max-width: initial;`}
  }
`
const Container = styled.div`
  max-width: 1248px;
  margin: 0 auto;
  padding: ${props => (props.alignCenter ? "104px 48px" : "72px 48px 48px")};
  display: flex;
  div {
    &:first-child {
      flex: 1;
      margin-right: 24px;
      ${below.mobile`margin-right: 0;`}
    }
    &:last-child {
      flex: 1;
      margin-left: 24px;
    }
  }
  ${below.mobile`
    padding: ${props => (props.alignCenter ? "64px 24px" : "48px 24px")};
    `}
`
const Headline = styled.h2`
  margin-bottom: 32px;
  text-align: left;
`
const ImageContainer = styled.div`
  display: flex;
  align-items: ${props => (props.alignCenter ? "center" : "flex-start")};
  justify-content: space-between;
  transform: ${props => props.alignCenter || "translateY(-180px)"};
  min-width: 360px;
  ${below.tablet`transform: ${props =>
    props.alignCenter || "translateY(-124px)"};`}
  ${below.mobile`display: none;`}
`

const ABCaresBanner = props => {
  return (
    <Wrapper
      backgroundColor={props.backgroundColor ? props.backgroundColor : null}
    >
      <Container alignCenter={props.alignCenter ? props.alignCenter : null}>
        <div>
          <Headline>Do good. Give back.</Headline>
          <p>
            Atlantic Bay Cares is the community outreach arm of Atlantic Bay
            Mortgage Group with the primary goal of changing lives in
            communities through doing good and giving back to causes meaningful
            to our employees.
          </p>

          <Button
            linkTo={
              getWalledLink(
                `/${props.walledSlug}/abcares/`,
                `/abcares/`,
                props.walledVersion,
                props.isMounted,
              ).link
            }
            buttonText="Check out AB Cares"
          />
        </div>
        <ImageContainer
          alignCenter={props.alignCenter ? props.alignCenter : null}
        >
          <img
            src={Build}
            alt="Atlantic Bay employee volunteers on RocSolid playset build"
            css={`
              margin-right: 12px;
            `}
          />
          <img
            src={Serve}
            alt="Atlantic Bay employee serves food at local homeless shelter"
            css={`
              transform: translateY(60px);
              margin-right: 12px;
            `}
          />
          <img
            src={Volunteer}
            alt="Atlantic Bay employee volunteers on community cleanup project"
            css={`
              transform: translateY(40px);
            `}
          />
        </ImageContainer>
      </Container>
    </Wrapper>
  )
}

export default ABCaresBanner
